
// import React, { useEffect, useMemo, useState } from "react";
// import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
// import MarkerClusterGroup from "react-leaflet-cluster";
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";
// import "./snappers-map-view.css";

// import { getSnapperMap } from "../services/snapperMapService";

// const INDIA_CENTER = [22.9734, 78.6569];

// function daysSince(value) {
//   if (!value) return Infinity;
//   return Math.max(0, Math.floor((Date.now() - new Date(value).getTime()) / 86400000));
// }

// function markerType(s) {
//   if (s.blocked) return "blocked";
//   const days = daysSince(s.last_login_at);
//   if (s.status === "active" && days <= 30 && Number(s.completed_jobs_30d) > 0) return "active-working";
//   if (s.status === "active" && days <= 30) return "active";
//   if (days <= 90) return "idle";
//   return "inactive";
// }

// function createClusterCustomIcon(cluster) {
//   const count = cluster.getChildCount();

//   return L.divIcon({
//     html: `
//       <div class="custom-cluster">
//         <span>${count}</span>
//       </div>
//     `,
//     className: "custom-cluster-wrapper",
//     iconSize: [52, 52],
//     iconAnchor: [26, 26],
//   });
// }

// function ResetIndia({ trigger }) {
//   const map = useMap();
//   React.useEffect(() => {
//     if (trigger) map.setView(INDIA_CENTER, 5);
//   }, [trigger, map]);
//   return null;
// }

// function Marker({ snapper, onSelect }) {
//   const type = markerType(snapper);
//   return (
//     <CircleMarker
//       center={[Number(snapper.lat), Number(snapper.long)]}
//       radius={7}
//       pathOptions={{ className: `snapper-marker snapper-marker--${type}`, weight: 2, fillOpacity: 0.95 }}
//       eventHandlers={{ click: () => onSelect?.(snapper) }}
//     >
//       <Popup>
//         <div className="snapper-popup">
//           <div className="snapper-popup__head">
//             <div className={`snapper-avatar snapper-avatar--${type}`}>
//               {(snapper.public_name || snapper.name || "?").slice(0, 1).toUpperCase()}
//             </div>
//             <div>
//               <strong>{snapper.public_name || snapper.name || "Unnamed Snapper"}</strong>
//               <span>{snapper.address || "Location not available"}</span>
//             </div>
//           </div>
//           <div className="snapper-popup__grid">
//             <div><small>Last Login</small><b>{snapper.last_login_at ? new Date(snapper.last_login_at).toLocaleDateString() : "Never"}</b></div>
//             <div><small>Jobs · 30d</small><b>{snapper.completed_jobs_30d ?? 0}</b></div>
//             <div><small>Jobs · 90d</small><b>{snapper.completed_jobs_90d ?? 0}</b></div>
//             <div><small>Status</small><b>{snapper.blocked ? "Blocked" : snapper.status || "Unknown"}</b></div>
//           </div>
//         </div>
//       </Popup>
//     </CircleMarker>
//   );
// }

// export default function SnappersMapView({
//   onSnapperSelect,
//   onRefresh
// }) {
//   const [snappers, setSnappers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   const [search, setSearch] = useState("");
//   const [activity, setActivity] = useState("all");
//   const [showLegend, setShowLegend] = useState(true);
//   const [reset, setReset] = useState(false);

//   const loadSnappers = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const response = await getSnapperMap();
//       setSnappers(response.points || []);
//     } catch (err) {
//       console.error("Failed to load snapper map:", err);
//       setError(err.message || "Failed to load snapper locations");
//       setSnappers([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadSnappers();
//   }, []);

//   const valid = useMemo(
//     () => (snappers || []).filter(s => Number.isFinite(Number(s.lat)) && Number.isFinite(Number(s.long))),
//     [snappers]
//   );

//   const filtered = useMemo(() => {
//     const q = search.trim().toLowerCase();
//     return valid.filter(s => {
//       const matchesSearch = !q || [s.name, s.public_name, s.address, s.id].filter(Boolean)
//         .some(v => String(v).toLowerCase().includes(q));
//       const type = markerType(s);
//       const matchesActivity =
//         activity === "all" ||
//         (activity === "working" && type === "active-working") ||
//         (activity === "active" && ["active-working", "active"].includes(type)) ||
//         (activity === "idle" && type === "idle") ||
//         (activity === "inactive" && type === "inactive") ||
//         (activity === "blocked" && type === "blocked");
//       return matchesSearch && matchesActivity;
//     });
//   }, [valid, search, activity]);

//   const stats = useMemo(() => {
//     const r = { total: valid.length, active: 0, working: 0, idle: 0, inactive: 0, blocked: 0 };
//     valid.forEach(s => {
//       const t = markerType(s);
//       if (t === "active-working") r.working++;
//       if (t === "active-working" || t === "active") r.active++;
//       if (t === "idle") r.idle++;
//       if (t === "inactive") r.inactive++;
//       if (t === "blocked") r.blocked++;
//     });
//     return r;
//   }, [valid]);

//   return (
//     <div className="snappers-map-page">
//       <div className="snappers-map-header">
//         <div>
//           <div className="eyebrow">FIELD NETWORK</div>
//           <h1>Snapper Coverage Map</h1>
//           <p>Geographic view of registered snappers with operational activity status.</p>
//         </div>
//         <button
//           className="map-btn"
//           onClick={() => {
//             setReset(v => !v);
//             loadSnappers();
//             onRefresh?.();
//           }}
//         >
//           ↻ Refresh
//         </button>
//       </div>

//       <div className="map-kpis">
//         <div className="map-kpi"><span>Mapped Snappers</span><strong>{stats.total.toLocaleString()}</strong></div>
//         <div className="map-kpi positive"><span>Active</span><strong>{stats.active.toLocaleString()}</strong></div>
//         <div className="map-kpi working"><span>Working · 30d</span><strong>{stats.working.toLocaleString()}</strong></div>
//         <div className="map-kpi warning"><span>Idle · 31–90d</span><strong>{stats.idle.toLocaleString()}</strong></div>
//         <div className="map-kpi danger"><span>Inactive · 90d+</span><strong>{stats.inactive.toLocaleString()}</strong></div>
//       </div>

//       <div className="map-toolbar">
//         <div className="map-search">
//           <span>⌕</span>
//           <input
//             value={search}
//             onChange={e => setSearch(e.target.value)}
//             placeholder="Search snapper or ID..."
//           />
//         </div>
//         <select value={activity} onChange={e => setActivity(e.target.value)}>
//           <option value="all">All Snappers</option>
//           <option value="working">Working · 30d</option>
//           <option value="active">Active · 30d</option>
//           <option value="idle">Idle · 31–90d</option>
//           <option value="inactive">Inactive · 90d+</option>
//           <option value="blocked">Blocked</option>
//         </select>
//         <button className="map-btn" onClick={() => setShowLegend(v => !v)}>{showLegend ? "Hide Legend" : "Show Legend"}</button>
//         <div className="map-result-count">Showing <b>{filtered.length}</b> of <b>{valid.length}</b></div>
//       </div>

//       <div className="map-shell">
//         {loading && <div className="map-loading">Loading snapper locations...</div>}
//         {error && <div className="map-error" style={{ color: "red", padding: "12px" }}>{error}</div>}

//         <MapContainer center={INDIA_CENTER} zoom={5} minZoom={4} maxZoom={18} scrollWheelZoom className="snappers-leaflet-map">
//           <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
//           <ResetIndia trigger={reset} />
//           <MarkerClusterGroup
//             chunkedLoading
//             showCoverageOnHover={false}
//             spiderfyOnMaxZoom
//             maxClusterRadius={45}
//             iconCreateFunction={createClusterCustomIcon}
//           >
//             {filtered.map(s => <Marker key={s.id} snapper={s} onSelect={onSnapperSelect} />)}
//           </MarkerClusterGroup>
//         </MapContainer>

//         {showLegend && (
//           <div className="map-legend">
//             <div className="map-legend-title">Snapper status</div>
//             {[
//               ["active-working", "Active + worked in last 30 days"],
//               ["active", "Active + logged in within 30 days"],
//               ["idle", "No recent activity (31–90 days)"],
//               ["inactive", "No login for 90+ days"],
//               ["blocked", "Blocked account"]
//             ].map(([type, label]) => (
//               <div className="legend-item" key={type}><span className={`legend-dot legend-dot--${type}`} /><span>{label}</span></div>
//             ))}
//             <div className="legend-note">Marker position = stored latitude / longitude.</div>
//           </div>
//         )}

//         <div className="map-live"><span /> Live location dataset</div>
//       </div>

//       <div className="map-footer-note">
//         <span><b>{valid.length - filtered.length}</b> snappers are outside the selected filter.</span>
//         <span>Snappers without valid latitude/longitude remain in Snapper Insight but are excluded from this map.</span>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useMemo, useState } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./snappers-map-view.css";

import { getSnapperMap } from "../services/snapperMapService";

const INDIA_CENTER = [22.9734, 78.6569];

function daysSince(value) {
  if (!value) return Infinity;
  return Math.max(0, Math.floor((Date.now() - new Date(value).getTime()) / 86400000));
}

function markerType(s) {
  if (s.blocked) return "blocked";
  const days = daysSince(s.last_login_at);
  if (s.status === "active" && days <= 30 && Number(s.completed_jobs_30d) > 0) return "active-working";
  if (s.status === "active" && days <= 30) return "active";
  if (days <= 90) return "idle";
  return "inactive";
}

function createClusterCustomIcon(cluster) {
  const count = cluster.getChildCount();

  return L.divIcon({
    html: `
      <div class="custom-cluster">
        <span>${count}</span>
      </div>
    `,
    className: "custom-cluster-wrapper",
    iconSize: [52, 52],
    iconAnchor: [26, 26],
  });
}

function ResetIndia({ trigger }) {
  const map = useMap();
  React.useEffect(() => {
    if (trigger) map.setView(INDIA_CENTER, 5);
  }, [trigger, map]);
  return null;
}

const Marker = React.memo(function Marker({ snapper, onSelect }) {
  const type = markerType(snapper);
  return (
    <CircleMarker
      center={[Number(snapper.lat), Number(snapper.long)]}
      radius={7}
      pathOptions={{ className: `snapper-marker snapper-marker--${type}`, weight: 2, fillOpacity: 0.95 }}
      eventHandlers={{ click: () => onSelect?.(snapper) }}
    >
      <Popup>
        <div className="snapper-popup">
          <div className="snapper-popup__head">
            <div className={`snapper-avatar snapper-avatar--${type}`}>
              {(snapper.public_name || snapper.name || "?").slice(0, 1).toUpperCase()}
            </div>
            <div>
              <strong>{snapper.public_name || snapper.name || "Unnamed Snapper"}</strong>
              <span>{snapper.address || "Location not available"}</span>
            </div>
          </div>
          <div className="snapper-popup__grid">
            <div><small>Last Login</small><b>{snapper.last_login_at ? new Date(snapper.last_login_at).toLocaleDateString() : "Never"}</b></div>
            <div><small>Jobs · 30d</small><b>{snapper.completed_jobs_30d ?? 0}</b></div>
            <div><small>Jobs · 90d</small><b>{snapper.completed_jobs_90d ?? 0}</b></div>
            <div><small>Status</small><b>{snapper.blocked ? "Blocked" : snapper.status || "Unknown"}</b></div>
          </div>
        </div>
      </Popup>
    </CircleMarker>
  );
});

export default function SnappersMapView({
  onSnapperSelect,
  onRefresh
}) {
  const [snappers, setSnappers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [search, setSearch] = useState("");
  const [activity, setActivity] = useState("all");
  const [showLegend, setShowLegend] = useState(true);
  const [reset, setReset] = useState(false);

  const loadSnappers = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await getSnapperMap();
      setSnappers(response.points || []);
    } catch (err) {
      console.error("Failed to load snapper map:", err);
      setError(err.message || "Failed to load snapper locations");
      setSnappers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSnappers();
  }, []);

  const valid = useMemo(
    () => (snappers || []).filter(s => Number.isFinite(Number(s.lat)) && Number.isFinite(Number(s.long))),
    [snappers]
  );

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    return valid.filter(s => {
      const matchesSearch = !q || [s.name, s.public_name, s.address, s.id].filter(Boolean)
        .some(v => String(v).toLowerCase().includes(q));
      const type = markerType(s);
      const matchesActivity =
        activity === "all" ||
        (activity === "working" && type === "active-working") ||
        (activity === "active" && ["active-working", "active"].includes(type)) ||
        (activity === "idle" && type === "idle") ||
        (activity === "inactive" && type === "inactive") ||
        (activity === "blocked" && type === "blocked");
      return matchesSearch && matchesActivity;
    });
  }, [valid, search, activity]);

  const stats = useMemo(() => {
    const r = { total: valid.length, active: 0, working: 0, idle: 0, inactive: 0, blocked: 0 };
    valid.forEach(s => {
      const t = markerType(s);
      if (t === "active-working") r.working++;
      if (t === "active-working" || t === "active") r.active++;
      if (t === "idle") r.idle++;
      if (t === "inactive") r.inactive++;
      if (t === "blocked") r.blocked++;
    });
    return r;
  }, [valid]);

  return (
    <div className="snappers-map-page">
      <div className="snappers-map-header">
        <div>
          <div className="eyebrow">SNAPPER COVERAGE MAP</div>
          
        </div>
        <button
          className="map-btn"
          onClick={() => {
            setReset(v => !v);
            loadSnappers();
            onRefresh?.();
          }}
        >
          ↻ Refresh
        </button>
      </div>

      <div className="map-kpis">
        <div className="map-kpi"><span>Mapped Snappers</span><strong>{stats.total.toLocaleString()}</strong></div>
        <div className="map-kpi positive"><span>Active</span><strong>{stats.active.toLocaleString()}</strong></div>
        <div className="map-kpi working"><span>Working · 30d</span><strong>{stats.working.toLocaleString()}</strong></div>
        <div className="map-kpi warning"><span>Idle · 31–90d</span><strong>{stats.idle.toLocaleString()}</strong></div>
        <div className="map-kpi danger"><span>Inactive · 90d+</span><strong>{stats.inactive.toLocaleString()}</strong></div>
      </div>

      <div className="map-toolbar">
        <div className="map-search">
          <span>⌕</span>
          <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search snapper or ID..."
          />
        </div>
        <select value={activity} onChange={e => setActivity(e.target.value)}>
          <option value="all">All Snappers</option>
          <option value="working">Working · 30d</option>
          <option value="active">Active · 30d</option>
          <option value="idle">Idle · 31–90d</option>
          <option value="inactive">Inactive · 90d+</option>
          <option value="blocked">Blocked</option>
        </select>
        <button className="map-btn" onClick={() => setShowLegend(v => !v)}>{showLegend ? "Hide Legend" : "Show Legend"}</button>
        <div className="map-result-count">Showing <b>{filtered.length}</b> of <b>{valid.length}</b></div>
      </div>

      <div className="map-shell">
        {loading && <div className="map-loading">Loading snapper locations...</div>}
        {error && <div className="map-error" style={{ color: "red", padding: "12px" }}>{error}</div>}

        <MapContainer center={INDIA_CENTER} zoom={5} minZoom={4} maxZoom={18} scrollWheelZoom className="snappers-leaflet-map">
          <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <ResetIndia trigger={reset} />
          <MarkerClusterGroup
            chunkedLoading
            chunkInterval={100}
            chunkDelay={25}
            showCoverageOnHover={false}
            spiderfyOnMaxZoom
            maxClusterRadius={(zoom) => {
              if (zoom <= 6) return 60;
              if (zoom <= 8) return 45;
              if (zoom <= 10) return 30;
              return 20;
            }}
            disableClusteringAtZoom={11}
            iconCreateFunction={createClusterCustomIcon}
          >
            {filtered.map(s => <Marker key={s.id} snapper={s} onSelect={onSnapperSelect} />)}
          </MarkerClusterGroup>
        </MapContainer>

        {showLegend && (
          <div className="map-legend">
            <div className="map-legend-title">Snapper status</div>
            {[
              ["active-working", "Active + worked in last 30 days"],
              ["active", "Active + logged in within 30 days"],
              ["idle", "No recent activity (31–90 days)"],
              ["inactive", "No login for 90+ days"],
              ["blocked", "Blocked account"]
            ].map(([type, label]) => (
              <div className="legend-item" key={type}><span className={`legend-dot legend-dot--${type}`} /><span>{label}</span></div>
            ))}
            <div className="legend-note">Marker position = stored latitude / longitude.</div>
          </div>
        )}

        <div className="map-live"><span /> Live location dataset</div>
      </div>

      <div className="map-footer-note">
        <span><b>{valid.length - filtered.length}</b> snappers are outside the selected filter.</span>
        <span>Snappers without valid latitude/longitude remain in Snapper Insight but are excluded from this map.</span>
      </div>
    </div>
  );
}